import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { dictionaryClientColumn } from '../constants/dictionary-client-columns.constant';
import { authHandle } from './auth.handle';
import EditableCell from '../components/EditableCell';

export const generateClientColumns = ({ statusNumber, quotationId, token, onUserInfoUpdate } = {}) => {
	const isEditable = statusNumber === 100;

	const renderEditable = (fieldKey) => (text) => {
		if (!isEditable) return text;
		return (
			<EditableCell
				value={text}
				fieldKey={fieldKey}
				quotationId={quotationId}
				token={token}
				onUpdate={onUserInfoUpdate}
			/>
		);
	};

	return [
		{
			title: dictionaryClientColumn[Enviroment.LANGUAGE].name,
			dataIndex: 'name',
			key: 'name',
			render: renderEditable('name'),
		},
		{
			title: dictionaryClientColumn[Enviroment.LANGUAGE].email,
			dataIndex: 'email',
			key: 'email',
			render: renderEditable('email'),
		},
		{
			title: dictionaryClientColumn[Enviroment.LANGUAGE].document,
			dataIndex: 'rut',
			key: 'rut',
			render: renderEditable('rut'),
		},
		{
			title: dictionaryClientColumn[Enviroment.LANGUAGE].phone,
			dataIndex: 'phone',
			key: 'phone',
			render: renderEditable('phone'),
		},
		{
			title: dictionaryClientColumn[Enviroment.LANGUAGE].status,
			dataIndex: 'auth',
			key: 'auth',
			render: (auth) => authHandle(auth),
		},
	];
};
